import hrms17eLabels from 'assets/labels/hrms17e'
import moment from 'moment'
import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms17eLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 10
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        codcomp: faker.random.word(),
        desc_codcomp: faker.company.companyName(),
        codpos: faker.random.word(),
        desc_codpos: faker.name.jobType(),
        dteefpos: moment().format('DD/MM/YYYY'),
        dteappr: moment().format('DD/MM/YYYY')
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  create () {
    let mockCreateRows = []
    const mockCreateTotal = 0
    for (var i = 1; i <= mockCreateTotal; i++) {
      mockCreateRows.push({
        kpino: '',
        kpiitem: '',
        kpiwgt: ''
      })
    }

    return {
      total: mockCreateTotal,
      rows: mockCreateRows
    }
  },
  detail1 () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        kpino: faker.date.past().toString().substr(0, 1),
        kpiitem: faker.random.words(),
        kpiwgt: faker.date.past().toString().substr(0, 1)
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  codempidQuery () {
    return {
      codcomp: faker.random.word(),
      desc_codcomp: faker.name.jobType(),
      codpos: faker.random.word(),
      desc_codpos: faker.name.title()
    }
  },
  createDetail2 () {
    let mockDetail2 = {
      kpino: faker.date.past().toString().substr(0, 1)
    }
    return {
      detail: mockDetail2
    }
  },
  detail2 () {
    let mockDetail2 = {
      kpino: faker.date.past().toString().substr(0, 1),
      kpiitem: '',
      kpiwgt: '',
      target: '',
      dtetarg: '',
      mtrunit: '',
      mtrvalue: ''
    }
    let mockDetail2Tab1Rows = []
    const mockDetail2Tab1Total = 1
    for (var a = 1; a <= mockDetail2Tab1Total; a++) {
      mockDetail2Tab1Rows.push({
        workno: a,
        workitem: faker.random.words()
      })
    }
    let mockDetail2Tab2Rows = []
    const mockDetail2Tab2Total = 1
    for (var b = 1; b <= mockDetail2Tab2Total; b++) {
      mockDetail2Tab2Rows.push({
        grdno: b,
        grditem: faker.random.arrayElement(),
        achieve: faker.random.words(),
        mtrvalst: faker.commerce.price(),
        mtrvalen: faker.commerce.price(),
        qtyscor: faker.commerce.price()
      })
    }

    return {
      detail: mockDetail2,
      tab1: {
        total: mockDetail2Tab1Total,
        rows: mockDetail2Tab1Rows
      },
      tab2: {
        total: mockDetail2Tab2Total,
        rows: mockDetail2Tab2Rows
      }
    }
  },
  dropdowns () {
    const mockMtrunit = {
      '1': 'ร้อยละ',
      '2': 'ระดับ',
      '3': 'ระยะเวลา',
      '4': 'รายการ',
      '5': 'รายไตรมาส',
      '6': 'ค่าเฉลี่ย',
      '7': 'ค่าเฉลี่ย/วัน',
      '8': 'หน่วย',
      '9': 'หน่วยวัด',
      '10': 'ครั้ง/ปี',
      '11': 'จำนวนวัน'
    }

    return {
      mtrunit: {
        en: mockMtrunit,
        th: mockMtrunit
      }
    }
  },
  importKpi () {
    return {
      'total': '2',
      'rows': [
        {
          'coderror': '200',
          'desc_coderror': 'HR2401 ข้อมูลได้รับการบันทึกแล้ว',
          'httpcode': '',
          'flg': '',
          'total': '2',
          'rcnt': '1',
          'desc_status': 'Success',
          'flg_status': 'S',
          'remark': '',
          'item1': '33072',
          'item2': '1',
          'item3': 'องค์ความรู้พื้นฐาน',
          'item4': 'ต้องได้คะแนนมากกว่า 80 เปอร์เซ็นต์',
          'item5': '1',
          'item6': '10.2',
          'item7': '7/10/58',
          'item8': '52115155.25',
          'item9': 'งานที่ทำ1_1',
          'item10': 'งานที่ทำ1_2',
          'item11': '',
          'item12': '',
          'item13': '',
          'item14': '',
          'item15': '',
          'item16': '',
          'item17': '',
          'item18': '',
          'item19': '',
          'item20': '',
          'item21': '',
          'item22': '',
          'item23': '',
          'item24': '',
          'item25': '',
          'item26': '',
          'item27': '',
          'item28': '',
          'item29': '1',
          'item30': 'พอใช้',
          'item31': '0',
          'item32': '50',
          'item33': '1',
          'item34': '2',
          'item35': 'ดี',
          'item36': '51',
          'item37': '80',
          'item38': '2',
          'item39': '3',
          'item40': 'ดีมาก',
          'item41': '81',
          'item42': '100',
          'item43': '3',
          'item44': '',
          'item45': '',
          'item46': '',
          'item47': '',
          'item48': '',
          'item49': '',
          'item50': '',
          'item51': '',
          'item52': '',
          'item53': '',
          'item54': '',
          'item55': '',
          'item56': '',
          'item57': '',
          'item58': '',
          'item59': '',
          'item60': '',
          'item61': '',
          'item62': '',
          'item63': '',
          'item64': '',
          'item65': '',
          'item66': '',
          'item67': '',
          'item68': '',
          'item69': '',
          'item70': '',
          'item71': '',
          'item72': '',
          'item73': '',
          'item74': '',
          'item75': '',
          'item76': '',
          'item77': '',
          'item78': ''
        },
        {
          'coderror': '200',
          'desc_coderror': 'HR2401 ข้อมูลได้รับการบันทึกแล้ว',
          'httpcode': '',
          'flg': '',
          'total': '2',
          'rcnt': '2',
          'desc_status': 'Success',
          'flg_status': 'S',
          'remark': '',
          'item1': '33072',
          'item2': '2',
          'item3': 'การจัดการระบบ',
          'item4': 'ต้องได้คะแนนมากกว่า 60 เปอร์เซ็นต์',
          'item5': '2',
          'item6': '99.99',
          'item7': '7/11/58',
          'item8': '85.52',
          'item9': 'งานที่ทำ2_1SSS',
          'item10': 'งานที่ทำ2_2SSS',
          'item11': '',
          'item12': '',
          'item13': '',
          'item14': '',
          'item15': '',
          'item16': '',
          'item17': '',
          'item18': '',
          'item19': '',
          'item20': '',
          'item21': '',
          'item22': '',
          'item23': '',
          'item24': '',
          'item25': '',
          'item26': '',
          'item27': '',
          'item28': '',
          'item29': '',
          'item30': '',
          'item31': '',
          'item32': '',
          'item33': '',
          'item34': '',
          'item35': '',
          'item36': '',
          'item37': '',
          'item38': '',
          'item39': '',
          'item40': '',
          'item41': '',
          'item42': '',
          'item43': '',
          'item44': '',
          'item45': '',
          'item46': '',
          'item47': '',
          'item48': '',
          'item49': '',
          'item50': '',
          'item51': '',
          'item52': '',
          'item53': '',
          'item54': '',
          'item55': '',
          'item56': '',
          'item57': '',
          'item58': '',
          'item59': '',
          'item60': '',
          'item61': '',
          'item62': '',
          'item63': '',
          'item64': '',
          'item65': '',
          'item66': '',
          'item67': '',
          'item68': '',
          'item69': '',
          'item70': '',
          'item71': '',
          'item72': '',
          'item73': '',
          'item74': '',
          'item75': '',
          'item76': '',
          'item77': '',
          'item78': ''
        }
      ]
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  },
  delete () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms17e/mocker.js